import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InvestmentFrequencyPipe } from './investment-frequency.pipe';

@NgModule({
  declarations: [
    InvestmentFrequencyPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    InvestmentFrequencyPipe
  ]
})
export class InvestmentFrequencyPipeModule { }
